var angular = require('angular')
angular.module('app').component('auiBreadcrumbs', {
  template: require('./breadcrumbs.html'),
  bindings: {
    item: '@',
    loaded: '='
  },

  controller: function ($scope, $element, $attrs, $http, ENDPOINT_SEARCH) {
    var ctrl = this
    ctrl.breadcrumbs = []
    ctrl.LINKS = document.location.origin + document.location.pathname
    ctrl.loaded = false
    ctrl.isLoaded = false

    ctrl.$onInit = function () {
      $http.post(ENDPOINT_SEARCH, {
        'table': 'hierarchy',
        'query': {'id': ctrl.item, 'access': {'$in': [1]}}
      })
      .then(function (data) {
        if (data.data.count <= 0) { return }
        ctrl.name = data.data.data[0].name
        if (data.data.count > 0) {
          let currentNode = data.data.data[0]
          if (currentNode.parent_path !== null && currentNode.parent_path !== '1') { // Risalgo la gerarchia
            $http.post(ENDPOINT_SEARCH, {
              'table': 'hierarchy',
              'query': {'id': {'$in': currentNode.parent_path.split('/')}, 'access': {'$in': [1]}},
              'fields': {'id': 1, 'name': 1, 'type': 1, 'num': 1}
            }).then(function (result) {
              // Aggiungo i padri all'albero
              var order = currentNode.parent_path.split('/')

              for (let i = 0; i < result.data.data.length; i++) {
                if (result.data.data[i].id === order[0]) {
                  ctrl.title = result.data.data[i].name
                }
                ctrl.titleId = result.data.data[i].id
              }
              order.shift()
              let newResult = []

              if (order.length > 0) {
                order.forEach(function (elem) {
                  for (let i = 0; i < result.data.data.length; i++) {
                    if (result.data.data[i].id === elem) {
                      newResult.push({
                        'id': result.data.data[i].id,
                        'name': result.data.data[i].name,
                        'table': result.data.data[i].table,
                        'num': result.data.data[i].num,
                        'type': result.data.data[i].type
                      })
                    }
                  }

                  ctrl.loaded = true
                  ctrl.isLoaded = true
                })
              } else {
                ctrl.loaded = true
                ctrl.isLoaded = true
              }

              if (result.data.count > 0) {
                for (let i = 0; i < newResult.length; i++) {
                  ctrl.breadcrumbs.push(newResult[i])
                }
                ctrl.breadcrumbs.push(currentNode)
              }
            })
          } else {
            ctrl.title = data.data.data[0].name
            ctrl.titleId = false
            ctrl.loaded = true
            ctrl.isLoaded = true
          }
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/js/components/breadcrumbs/breadcrumbs.js